import * as Yup from 'yup';
import { commonValidation } from './validations/validationRule';
import { FILE_SIZE, SUPPORTED_GOV_FORMATS } from '../constants/common';
import { GlobalValidation } from './validations/commonValidation';

const passwordRegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9])\S{8,}$/;

export const STEPONE_VALIDATION = {
  // isUsCitizen: Yup.string().required('Required field'),

  dateOfBirth: Yup.string().required('Required field').nullable(),
  hireDate: Yup.string().required('Required field').nullable(),
  companyTickerSymbol: Yup.string()
    .required('Required field')
    .matches(/^[a-zA-Z ]*$/, 'Invalid Ticker')
    .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces'),
  code: Yup.string()
    .required('Required field')
    .matches(/^[0-9]*$/, 'Must be only digits')
    .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces'),
};
export const STEPTWO_VALIDATION = Yup.object().shape({
  email: Yup.string().email('Email is invalid').required('Required field'),
  confirmemail: Yup.string()
    .required('Required field')
    .test('match', 'Email do not match', function (confirmemail) {
      return confirmemail === this.parent.email;
    }),
});
export const STEP_THREE_VALIDATION = Yup.object().shape({
  password: Yup.string().required('Required field').matches(passwordRegExp, 'Invalid Password'),
  confirmPassword: Yup.string()
    .required('Required field')
    .test('match', 'Password do not match', function (confirmPassword) {
      return confirmPassword === this.parent.password;
    }),
});
export const STEP_FOUR_VALIDATION = Yup.object().shape({
  securityQuestion1: Yup.string().required('Required field').nullable(),
  securityQuestion2: Yup.string().required('Required field').nullable(),
  securityQuestion3: Yup.string().required('Required field').nullable(),
  securityAnswer1: Yup.string()
    .required('Required field')
    .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces'),
  securityAnswer2: Yup.string()
    .required('Required field')
    .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces'),
  securityAnswer3: Yup.string()
    .required('Required field')
    .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces'),
});
// export const STEPTWO_VALIDATION = Yup.object().shape({
//   userName: Yup.string().email('Email is invalid').required('Required field'),
//   password: Yup.string().required('Required field').matches(passwordRegExp, 'Invalid Password'),
//   confirmPassword: Yup.string()
//     .required('Required field')
//     .test('match', 'Password do not match', function (confirmPassword) {
//       return confirmPassword === this.parent.password;
//     }),
//
// });

// export const STEP_THREE_VALIDATION = {
//   firstName: Yup.string()
//     .required('Required field')
//     .matches(/^[a-zA-Z ]*$/, 'Invalid First Name')
//     .max(100, 'Exceeds max characters')
//     .min(0, 'Exceeds min characters')
//     .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
//     .nullable(),
//   middleName: Yup.string()
//     .matches(/^[a-zA-Z ]*$/, 'Invalid Middle Name')
//     .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
//     .nullable(),
//   lastName: Yup.string()
//     .required('Required field')
//     .matches(/^[a-zA-Z ]*$/, 'Invalid Last Name')
//     .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
//     .nullable(),
//   dateOfBirth: Yup.string().required('Required field').nullable(),
//   fullLegalName: Yup.string()
//     .required('Required field')
//     .matches(/^[a-zA-Z ]*$/, 'Invalid Legal Name')
//     .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
//     .nullable(),
//   governmentDocumentIdNo: Yup.string()
//     .matches(/^[0-9]*$/, 'Must be only digits')
//     .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
//     .nullable(),
//   governmentDocumentIdIssuedStateText: Yup.string()
//     .matches(/^[a-zA-Z ]*$/, 'Invalid State Name')
//     .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
//     .nullable(),
//   governmentDocumentIdIssuedCityText: Yup.string()
//     .matches(/^[a-zA-Z ]*$/, 'Invalid City Name')
//     .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
//     .nullable(),
//   governmentDocumentIdZipOrPostalCode: Yup.string()
//     .max(5, 'Maximum 5 dight only')
//     .matches(/^[0-9]*$/, 'Must be only digits')
//     .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
//     .nullable(),
//   currentHomeAddressCountryId: Yup.string().required('Required field').nullable(),

//   addressLine1: Yup.string()
//     .required('Required field')
//     .matches(/^[a-zA-Z ]*$/, 'Invalid Address One')
//     .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
//     .nullable(),
//   currentHomeAddressLine2: Yup.string()
//     .matches(/^[a-zA-Z ]*$/, 'Invalid Address Two')
//     .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
//     .nullable(),
//   currentHomeAddressStartDate: Yup.string().required('Required field').nullable(),
//   currentHomeAddressZipPostalCode: Yup.string()
//     .required('Required field')
//     .max(5, 'Maximum 5 dight only')
//     .matches(/^[0-9]*$/, 'Must be only digits')
//     .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
//     .nullable(),
//   currentHomeAddressHomePhone: Yup.string()
//     .max(10, 'Maximum 10 dight only')
//     .matches(/^[0-9]*$/, 'Must be only digits')
//     .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
//     .nullable(),
//   currentHomeAddressMobilePhone: Yup.string()
//     .required('Required field')
//     .max(10, 'Maximum 10 dight only')
//     .matches(/^[0-9]*$/, 'Must be only digits')
//     .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
//     .nullable(),

//   jobTitle: Yup.string()
//     .matches(/^[a-zA-Z ]*$/, 'Invalid Job Title')
//     .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
//     .nullable(),
//   workEmail: Yup.string().email('Email is invalid').required('Required field').nullable(),
//   employerName: Yup.string()
//     .matches(/^[a-zA-Z ]*$/, 'Invalid Employer Name')
//     .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
//     .nullable(),
//   employmentStateText: Yup.string()
//     .matches(/^[a-zA-Z ]*$/, 'Invalid State Name')
//     .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
//     .nullable(),
//   employmentCityText: Yup.string()
//     .matches(/^[a-zA-Z ]*$/, 'Invalid City Name')
//     .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
//     .nullable(),
//   employmentAddressLine1: Yup.string()
//     .matches(/^[a-zA-Z ]*$/, 'Invalid Employment Address One')
//     .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
//     .nullable(),
//   employmentAddressLine2: Yup.string()
//     .matches(/^[a-zA-Z ]*$/, 'Invalid Employment Address Two')
//     .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
//     .nullable(),
//   employmentZipPostalCode: Yup.string()
//     .max(5, 'Maximum 5 dight only')
//     .matches(/^[0-9]*$/, 'Must be only digits')
//     .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
//     .nullable(),
// };

export const Updated_Validation = {
  AddressLine1: commonValidation({
    required: true,
    noBlank: true,
    doubleSpace: true,
  }),
  AddressLine2: commonValidation({
    required: false,
    noBlank: true,
    doubleSpace: true,
  }),
};

export const ON_BOARDING_STEP_ONE_VALIDATION = {
  // Personal Details
  firstName: GlobalValidation.Name.matches(/^[a-z,0-9, @()-/*"':;_#-+]+$/i, 'Invalid First Name'),
  middleName: commonValidation({
    required: false,
    textLimit: 100,
    noBlank: true,
    doubleSpace: true,
  }).matches(/^[a-z,0-9, @()-/*"':;_#-+]+$/i, 'Invalid First Name'),
  lastName: GlobalValidation.Name.matches(
    /^[a-z,0-9, @()-/*"':;_#-+]+$/i,
    'Invalid First Name'
  ).label('Last Name'),
  dateOfBirth: Yup.string().required('Required field').nullable(),
  genderId: Yup.string().required('Required field').nullable(),
  maritalStatusId: Yup.string().required('Required field').nullable(),
  // US Residency and Citizenship Information
  // fullLegalName: Yup.string()
  //   .required('Required field')
  //   .matches(/^[a-zA-Z ]*$/, 'Invalid Legal Name')
  //   .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
  //   .nullable(),
  countryOfLegalResidencyId: commonValidation({
    required: true,
  }),
  governmentDocumentIdNo: Yup.string()
    .nullable()
    .when(['isUsCitizen', 'isUsResidentAlien', 'isNonUsResidentAlien'], {
      is: (isUsCitizen: boolean, isUsResidentAlien: boolean, isNonUsResidentAlien: boolean) => {
        if (!isUsCitizen && !isUsResidentAlien && isNonUsResidentAlien) {
          return true;
        }
      },
      then: (schema) => GlobalValidation.RequiredNoBlankAlphanumeric,

      // schema
      //   .required('Required field')
      //   // .matches(/^[0-9]*$/, 'Must be only digits')
      //   .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
      //   .nullable(),
    }),
  governmentDocumentIdIssueDate: Yup.date()
    .typeError('Required field')
    .nullable()
    .when(['isUsCitizen', 'isUsResidentAlien', 'isNonUsResidentAlien'], {
      is: (isUsCitizen: boolean, isUsResidentAlien: boolean, isNonUsResidentAlien: boolean) => {
        if (!isUsCitizen && !isUsResidentAlien && isNonUsResidentAlien) {
          return true;
        }
      },
      then: (schema) => schema.required('Required field').typeError('Required field').nullable(),
    }),
  governmentDocumentExpirationDate: Yup.string()
    .nullable()
    .when(
      ['isUsCitizen', 'isUsResidentAlien', 'isNonUsResidentAlien', 'governmentDocumentIdIssueDate'],
      {
        is: (
          isUsCitizen: boolean,
          isUsResidentAlien: boolean,
          isNonUsResidentAlien: boolean,
          governmentDocumentIdIssueDate: string
        ) => {
          if (!governmentDocumentIdIssueDate) {
            return false;
          }
          if (!isUsCitizen && !isUsResidentAlien && isNonUsResidentAlien) {
            return true;
          }
        },
        then: (schema) => schema.required('Required field').nullable(),
      }
    ),
  governmentDocumentTypeId: Yup.string()
    .nullable()
    .when(['isUsCitizen', 'isUsResidentAlien', 'isNonUsResidentAlien'], {
      is: (isUsCitizen: boolean, isUsResidentAlien: boolean, isNonUsResidentAlien: boolean) => {
        if (!isUsCitizen && !isUsResidentAlien && isNonUsResidentAlien) {
          return true;
        }
      },
      then: (schema) => schema.required('Required field').nullable(),
    }),

  governmentDocuments: Yup.array()
    .of(
      Yup.mixed()
        .test('fileFormat', 'Unsupported file format', (value) => {
          if (value?.file != null) {
            return (
              Boolean(value) &&
              SUPPORTED_GOV_FORMATS.some((item) => item?.format === value?.file?.type)
            );
          } else {
            return (
              Boolean(value) && SUPPORTED_GOV_FORMATS.some((item) => item?.format === value?.type)
            );
          }
        })
        .test('fileSize', 'File is too large', (value) => {
          if (value?.size <= FILE_SIZE || value?.file?.size <= FILE_SIZE) {
            return true;
          } else {
            return false;
          }
        })
    )
    .when(['isUsCitizen', 'isUsResidentAlien', 'isNonUsResidentAlien'], {
      is: (isUsCitizen: boolean, isUsResidentAlien: boolean, isNonUsResidentAlien: boolean) => {
        if (!isUsCitizen && !isUsResidentAlien && isNonUsResidentAlien) {
          return true;
        }
      },
      then: (schema) => schema.min(1, 'Required field').nullable(),
    }),
  socialSecurityNumber: Yup.string()
    .nullable()
    .when(['isOtherCountry', 'isNonUsResidentAlien'], {
      is: (isOtherCountry: any, isNonUsResidentAlien: any) => {
        if (isNonUsResidentAlien) {
          return true; // If isCountryOfLegalResidencyOtherCountry is true, SSN is not required
        }
        return false;
      },
      then: Yup.string().nullable(), // Not required if isCountryOfLegalResidencyOtherCountry is true
      otherwise: Yup.string().when('isOtherCountry', {
        is: true,
        then: GlobalValidation.NoBlankAlphanumeric, // If isOtherCountry is true but isCountryOfLegalResidencyOtherCountry is false
        otherwise: GlobalValidation.ValidateSSN, // If both are false, apply ValidateSSN
      }),
    }),
  residenceStatusId: commonValidation({
    required: true,
  }),
  // governmentDocumentIdIssueDate: Yup.string().required('Required field').nullable(),
  // governmentDocumentExpirationDate: Yup.string().required('Required field').nullable(),
  // governmentDocumentTypeId: Yup.string().required('Required field').nullable(),
  // governmentDocumentIdIssuedStateText: Yup.string()
  //   .matches(/^[a-zA-Z ]*$/, 'Invalid State Name')
  //   .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
  //   .nullable(),
  // governmentDocumentIdIssuedCityText: Yup.string()
  //   .matches(/^[a-zA-Z ]*$/, 'Invalid City Name')
  //   .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
  //   .nullable(),
  // governmentDocumentIdZipOrPostalCode: Yup.string()
  //   .min(5, 'Must be 5 digits')
  //   .max(5, 'Must be 5 digits')
  //   .matches(/^[0-9]*$/, 'Must be only digits')
  //   .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
  //   .nullable(),

  // Home Address
  currentHomeAddressCountryId: Yup.string().required('Required field').nullable(),
  // currentHomeAddressCityText: Yup.string().required('Required field').nullable(),
  // addressLine1: GlobalValidation.AddressLine1.nullable(),
  // currentHomeAddressLine2: GlobalValidation.AddressLine2.nullable(),
  addressLine1: Updated_Validation.AddressLine1,
  currentHomeAddressLine2: Updated_Validation.AddressLine2,
  currentHomeAddressStateId: Yup.string()
    .required('Required field')
    .nullable()
    .when('isOtherHomeCountry', {
      is: (val: any) => {
        if (typeof val === 'boolean') {
          return val;
        }
        return true;
      },
      then: () =>
        commonValidation({
          required: false,
          alphanumeric: true,
          noBlank: true,
        }),
      otherwise: (d: any) =>
        commonValidation({
          required: true,
          alphanumeric: true,
          noBlank: true,
        }),
    }),
  currentHomeAddressStateText: commonValidation({
    required: false,
    alphanumeric: false, // alphanumeric: true, changed to false as per prod feedback for making free form
  })
    .nullable()
    .when('isOtherHomeCountry', {
      is: true,
      otherwise: (d: any) => Yup.string().nullable(),
    }),
  currentHomeAddressZipPostalCode: Yup.string()
    .nullable()
    .min(5, 'Must be 5 digits')
    .max(5, 'Must be 5 digits')
    .when('currentHomeAddresszipCodeErrorMessage', (value: any, schema: any) => {
      if (value != null && value != undefined) {
        return schema.test(
          'zipCodeValidation', // Name for the test
          value, // Custom error message
          (val: any) => val === true // Test function
        );
      }
      return schema;
    })
    .when('isOtherHomeCountry', {
      is: (val: any) => {
        if (typeof val === 'boolean') {
          return val;
        }
        return true;
      },
      then: () => commonValidation({ required: false, noBlank: true }),
      otherwise: () => GlobalValidation.ZipCode,
    }),
  // currentHomeAddressCityText: Yup.string().required('Required field').nullable(),
  // currentHomeAddressStartDate: Yup.date()
  //   .required('Required field')
  //   .typeError('Required field')
  //   .nullable(),
  currentHomeAddressCityText: commonValidation({
    required: false,
    noBlank: true,
    alphanumeric: false, // alphanumeric: true, changed to false as per prod feedback for making free form
  }).nullable(),
  // addressLine1: Yup.string()
  //   .required('Required field')
  //   // .matches(/^[a-zA-Z0-9 ]+$/, 'Invalid Address One')
  //   .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
  //   .nullable(),
  // currentHomeAddressLine2: Yup.string()
  //   // .required('Required field')
  //   // .matches(/^[a-zA-Z0-9 ]+$/, 'Invalid Address Two')
  //   .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
  //   .nullable(),

  currentHomeAddressMobilePhone: commonValidation({
    required: true,
    numericPhone: true,
    noBlank: true,
  })
    .min(12, 'Must be 10 digits')
    .when('isOtherCountryPhone', {
      is: false,
      otherwise: (d: any) =>
        commonValidation({
          required: true,
          numericPhone: true,
          noBlank: true,
        }),
    }),
  currentHomeAddressHomePhone: commonValidation({
    required: false,
    numericPhone: true,
    noBlank: true,
  })
    .min(12, 'Must be 10 digits')
    .when('isHomePhoneOtherCountryPhone', {
      is: false,
      otherwise: (d: any) =>
        commonValidation({
          required: false,
          numericPhone: true,
          noBlank: true,
        }),
    }),
  // workPhone: Yup.string().required('Required field').nullable(),
  workPhone: commonValidation({
    required: false,
    numericPhone: true,
    noBlank: true,
  })
    .min(12, 'Must be 10 digits')
    .when('isWorkPhoneOtherCountryPhone', {
      is: false,
      otherwise: (d: any) =>
        commonValidation({
          required: false,
          numericPhone: true,
          noBlank: true,
        }),
    }),

  // currentHomeAddressZipPostalCode: commonValidation({
  //   required: true,
  //   digits: true,
  // })
  //   .min(5, 'Must be 5 digits')
  //   .max(5, 'Must be 5 digits')
  //   .when('isOtherHomeCountry', {
  //     is: false,
  //     otherwise: (d: any) =>
  //       commonValidation({
  //         required: true,
  //         digits: true,
  //       }),
  //   }),
  // currentHomeAddressMobilePhone: Yup.string().required('Required field').nullable(),

  //mailing validation
  mailingAddressZipPostalCode: Yup.string()
    .nullable()
    .when('mailingAddresszipCodeErrorMessage', (value: any, schema: any) => {
      if (value != null && value != undefined) {
        return schema.test(
          'mailingAddresszipCodeValidation', // Name for the test
          value, // Custom error message
          (val: any) => val === true // Test function
        );
      }
      return schema;
    })
    .when(['isMailingAddress', 'isOtherMailingCountry'], {
      is: (isMailingAddress: boolean, isOtherMailingCountry: boolean) => {
        if (isMailingAddress && !isOtherMailingCountry) {
          return false;
        }
        return true;
      },
      then: () => commonValidation({ required: false, noBlank: true }),
      otherwise: () => GlobalValidation.ZipCode,
    }),

  // mailingAddressLine1: Yup.string()
  //   .required('Required field')
  //   .matches(/^\s*\S[\s\S]*$/, 'This field cannot contain only blank spaces')
  //   .nullable(),
  // mailingAddressLine2: Yup.string()
  //   .matches(/^\s*\S[\s\S]*$/, 'This field cannot contain only blank spaces')
  //   .matches(/^[a-zA-Z0-9 .,']*$/, 'Must be alphanumeric')
  //   .nullable(),

  mailingAddressStateId: Yup.string()
    .required('Required field')
    .nullable()
    .when(['isMailingAddress', 'isOtherMailingCountry'], {
      is: (isMailingAddress: boolean, isOtherMailingCountry: any) => {
        if (isMailingAddress && isOtherMailingCountry === false) {
          return true;
        }
      },
      otherwise: (d: any) =>
        commonValidation({
          required: false,
        }),
    }),
  mailingAddressStateText: commonValidation({
    required: false,
    alphanumeric: false, // alphanumeric: true, changed to false as per prod feedback for making free form
  })
    .nullable()
    .when('isOtherMailingCountry', {
      is: true,
      otherwise: (d: any) => Yup.string().nullable(),
    }),
  mailingAddressCityText: commonValidation({
    required: false,
    alphanumeric: false, // alphanumeric: true, changed to false as per prod feedback for making free form
  })
    .nullable()
    .when('isMailingAddress', {
      is: true,
      otherwise: (d: any) => Yup.string().nullable(),
    }),
  // mailingAddressStateText: Yup.string()
  //   .required('Required field')
  //   .nullable()
  //   .when('isOtherMailingCountry', {
  //     is: true,
  //     otherwise: (d: any) => Yup.string().nullable(),
  //   }),
  // mailingAddressCityText: Yup.string()
  //   .required('Required field')
  //   .nullable()
  //   .when('isMailingAddress', {
  //     is: true,
  //     otherwise: (d: any) => Yup.string().nullable(),
  //   }),

  employerName: Yup.string()
    // .required('Required field')
    // .matches(/^[a-zA-Z ]*$/, 'Invalid Employer Name')
    .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
    .nullable(),
  // employmentAddressLine1: Yup.string()
  //   // .matches(/^[a-zA-Z0-9 .,']*$/, 'Must be alphanumeric')
  //   .matches(/^[a-zA-Z0-9 .,'-]*$/, 'Must be alphanumeric')
  //   .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
  //   .nullable(),
  // employmentAddressLine2: Yup.string()
  //   // .matches(/^[a-zA-Z0-9 .,']*$/, 'Must be alphanumeric')
  //   .matches(/^[a-zA-Z0-9 .,'-]*$/, 'Must be alphanumeric')
  //   .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
  //   .nullable(),

  employmentAddressLine1: Updated_Validation.AddressLine1,
  employmentAddressLine2: Updated_Validation.AddressLine2,

  // employmentCountryId: commonValidation({ required: true }),
  employmentCountryId: Yup.string().nullable(),
  employmentCityText: commonValidation({
    required: false,
    alphanumeric: false, // alphanumeric: true, changed to false as per prod feedback for making free form
    noBlank: true,
  }),
  employmentZipPostalCode: Yup.string()
    .nullable()
    .when('isEmploymentOtherCountry', {
      is: (val: any) => {
        if (typeof val === 'boolean') {
          return val;
        }
        return true;
      },
      then: () => commonValidation({ required: false, noBlank: true }),
      otherwise: () => GlobalValidation.ZipCode,
    }),
  employmentStateId: Yup.string()
    .nullable()
    .when('isEmploymentOtherCountry', {
      is: (val: any) => {
        if (typeof val === 'boolean') {
          return val;
        }
        return true;
      },
      then: () =>
        commonValidation({
          required: false,
          alphanumeric: true,
          noBlank: true,
        }),
      otherwise: (d: any) =>
        commonValidation({
          required: true,
          alphanumeric: true,
          noBlank: true,
        }),
    }),

  employmentStateText: commonValidation({
    required: false,
    alphanumeric: false, // alphanumeric: true, changed to false as per prod feedback for making free form
    noBlank: true,
  }),

  /* residenceStatus: commonValidation({ required: true }), */
  // employmentStateId: commonValidation({ required: true }).when('isOtherCountry', {
  //   is: false,
  //   otherwise: (d: any) => Yup.string().nullable(),
  // }),
  // employmentCityId: commonValidation({ required: true }).when('isOtherCountry', {
  //   is: false,
  //   otherwise: (d: any) => Yup.string().nullable(),
  // }),
  // employmentCityText: commonValidation({ required: true }).when('isOtherCountry', {
  //   is: true,
  //   otherwise: (d: any) => Yup.string().nullable(),
  // }),
  // employmentStateText: commonValidation({ required: true }).when('isOtherCountry', {
  //   is: true,
  //   otherwise: (d: any) => Yup.string().nullable(),
  // }),
  // mailingAddressZipPostalCode: commonValidation({
  //   required: true,
  //   digits: true,
  // })
  //   .min(5, 'Must be 5 digits')
  //   .max(5, 'Must be 5 digits')
  //   .when(['isMailingAddress', 'isMailingAddressOtherCountry'], {
  //     is: (isMailingAddress: boolean, isMailingAddressOtherCountry: boolean) => {
  //       if (isMailingAddress && !isMailingAddressOtherCountry) {
  //         return true;
  //       }
  //     },
  //     otherwise: (d: any) =>
  //       commonValidation({
  //         digits: true,
  //       }),
  //   }),
  mailingAddressLine1: Updated_Validation.AddressLine1.nullable().when(
    ['isMailingAddress', 'isMailingAddressOtherCountry'],
    {
      is: (isMailingAddress: boolean, isMailingAddressOtherCountry: boolean) => {
        if (isMailingAddress && !isMailingAddressOtherCountry) {
          return true;
        }
      },
      otherwise: (d: any) =>
        commonValidation({
          required: false,
        }),
    }
  ),
  mailingAddressLine2: Updated_Validation.AddressLine2.nullable(),
  mailingAddressCountryId: Yup.string()
    .required('Required field')
    .nullable()
    .when(['isMailingAddress', 'isMailingAddressOtherCountry'], {
      is: (isMailingAddress: boolean, isMailingAddressOtherCountry: boolean) => {
        if (isMailingAddress && !isMailingAddressOtherCountry) {
          return true;
        }
      },
      otherwise: (d: any) =>
        commonValidation({
          required: false,
        }),
    }),

  // employmentZipPostalCode: commonValidation({
  //   required: true,
  //   digits: true,
  // })
  //   .min(5, 'Must be 5 digits')
  //   .max(5, 'Must be 5 digits'),
  // employmentZipPostalCode: commonValidation({
  //   required: true,
  //   digits: true,
  // })
  //   .min(5, 'Must be 5 digits')
  //   .max(5, 'Must be 5 digits')
  //   .when('mailingAddresszipCodeErrorMessage', (value: any, schema: any) => {
  //     if (value != null && value != undefined) {
  //       return schema.test(
  //         'mailingAddresszipCodeValidation', // Name for the test
  //         value, // Custom error message
  //         (val: any) => val === true // Test function
  //       );
  //     }
  //     return schema;
  //   })
  //   .when('isEmploymentOtherCountry', {
  //     is: true,
  //     otherwise: (d: any) =>
  //       commonValidation({
  //         required: false,
  //         // digits: true,
  //         alphanumeric: true,
  //       }),
  //   }),
  // employmentStateId: Yup.string()
  //   .required('Required field')
  //   .nullable()
  //   .when('isEmploymentOtherCountry', {
  //     is: true,
  //     otherwise: (d: any) => Yup.string().nullable(),
  //   }),
  // employmentStateText: commonValidation({
  //   required: false,
  //   // digits: true,
  //   alphanumeric: true,
  // }) /* Yup.string()
  //   .required('Required field') */
  //   .when('isEmploymentOtherCountry', {
  //     is: true,
  //     otherwise: (d: any) => Yup.string().nullable(),
  //   }),
};

export const ON_BOARDING_STEP_TWO_VALIDATION = Yup.object().shape({
  accountTypeId: Yup.string().required('Required field').nullable(),
  registrationTypeId: Yup.string().required('Required field').nullable(),

  // Investment Activities
  participantInvestmentObjectiveId: Yup.string().required('Required field').nullable(),
  participantInvestmentExperienceId: Yup.string().required('Required field').nullable(),
  participantAnnualIncomeId: Yup.string().required('Required field').nullable(),
  participantLiquidNetWorthId: Yup.string().required('Required field').nullable(),
  participantTotalNetWorthId: Yup.string().required('Required field').nullable(),
  numberOfDependents: Yup.string()
    .required('Required field')
    .matches(/^[0-9]*$/, 'Must be whole number')
    .nullable(),
  // beneficiary
  beneficiaryEmail: Yup.string().email('Email is invalid').required('Required field'),

  beneficiaryFirstName: Yup.string()
    .required('Required field')
    .matches(/^[a-zA-Z ]*$/, 'Invalid First Name')
    .max(100, 'Exceeds max characters')
    .min(0, 'Exceeds min characters')
    .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
    .nullable(),

  beneficiaryLastName: Yup.string()
    .required('Required field')
    .matches(/^[a-zA-Z ]*$/, 'Invalid Last Name')
    .max(100, 'Exceeds max characters')
    .min(0, 'Exceeds min characters')
    .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
    .nullable(),

  beneficiaryMiddleName: Yup.string()
    .matches(/^[a-zA-Z. ]*$/, 'Invalid Middle Name')
    .max(100, 'Exceeds max characters')
    .min(0, 'Exceeds min characters')
    .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
    .nullable(),
  beneficiaryRelationshipId: Yup.string()
    .required('Required field')
    .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
    .nullable(),
  beneficiaryMobileNumber: commonValidation({
    required: true,
    numericPhone: true,
    noBlank: true,
  })
    .min(12, 'Must be 10 digits')
    .when('isOtherCountryPhone', {
      is: false,
      otherwise: (d: any) =>
        commonValidation({
          required: true,
          numericPhone: true,
          noBlank: true,
        }),
    }),
});
// export const ON_BOARDING_STEP_FOUR_VALIDATION = Yup.object().shape({
//   employeedByARegisteredBrokerDealer: Yup.boolean()
//     .oneOf([true], 'You must accept the terms and conditions')
//     .nullable(),
// });

export const ON_BOARDING_VALIDATION = {
  // Personal Details
  firstName: Yup.string()
    .required('Required field')
    .matches(/^[a-zA-Z ]*$/, 'Invalid First Name')
    .max(100, 'Exceeds max characters')
    .min(0, 'Exceeds min characters')
    .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
    .nullable(),
  middleName: Yup.string()
    .matches(/^[a-zA-Z .]*$/, 'Invalid Middle Name')
    .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
    .nullable(),
  lastName: Yup.string()
    .required('Required field')
    .matches(/^[a-zA-Z ]*$/, 'Invalid Last Name')
    .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
    .nullable(),
  dateOfBirth: Yup.string().required('Required field').nullable(),

  // US Residency and Citizenship Information
  fullLegalName: Yup.string()
    .required('Required field')
    .matches(/^[a-zA-Z ]*$/, 'Invalid Legal Name')
    .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
    .nullable(),
  countryOfLegalResidencyId: Yup.string().required('Required field').nullable(),

  // Home Address
  currentHomeAddressCountryId: Yup.string().required('Required field').nullable(),
  addressLine1: Yup.string()
    .required('Required field')
    .matches(/^[a-zA-Z ]*$/, 'Invalid Address One')
    .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
    .nullable(),
  currentHomeAddressLine2: Yup.string()
    .required('Required field')
    .matches(/^[a-zA-Z ]*$/, 'Invalid Address Two')
    .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
    .nullable(),
  currentHomeAddressHomePhone: Yup.string().required('Required field').nullable(),
  currentHomeAddressZipPostalCode: Yup.string()
    .required('Required field')
    .max(5, 'Maximum 5 dight only')
    .matches(/^[0-9]*$/, 'Must be only digits')
    .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
    .nullable(),
  currentHomeAddressMobilePhone: Yup.string()
    .required('Required field')
    .max(10, 'Maximum 10 dight only')
    .matches(/^[0-9]*$/, 'Must be only digits')
    .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
    .nullable(),

  // Employment Information
  employerName: Yup.string()
    .required('Required field')
    .matches(/^[a-zA-Z ]*$/, 'Invalid Employer Name')
    .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
    .nullable(),
  employmentZipPostalCode: commonValidation({
    required: true,
    digits: true,
  })
    .min(5, 'Must be 5 digits')
    .max(5, 'Must be 5 digits')
    .when('isEmploymentOtherCountry', {
      is: false,
      otherwise: (d: any) => Yup.string().nullable(),
    }),

  // Account details
  accountTypeId: Yup.string().required('Required field').nullable(),
  registrationTypeId: Yup.string().required('Required field').nullable(),

  // Investment Activities
  participantInvestmentObjectiveId: Yup.string().required('Required field').nullable(),
  participantAnnualIncomeId: Yup.string().required('Required field').nullable(),
  participantLiquidNetWorthId: Yup.string().required('Required field').nullable(),
  participantTotalNetWorthId: Yup.string().required('Required field').nullable(),
};

export const PARTICIPANT_ADDRESS_DETAILS_VALIDATION = {
  firstName: commonValidation({
    required: true,
    max: 100,
    min: 0,
    noBlank: true,
    isText: true,
  }),
  middleName: Yup.string()
    .matches(/^[a-zA-Z .]*$/, 'Invalid Middle Name')
    .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
    .nullable(),
  lastName: commonValidation({
    required: true,
    max: 100,
    min: 0,
    noBlank: true,
    isText: true,
  }),
  dateOfBirth: commonValidation({ required: true }),
  maritalStatusId: commonValidation({ required: true }),
  genderId: commonValidation({ required: true }),
  currentHomeAddress: Yup.object().shape({
    addressLine1: commonValidation({ required: true, noBlank: true }),
    addressLine2: commonValidation({ noBlank: true }),
    countryId: commonValidation({ required: true }),
    city: commonValidation({ required: true }),
    zipCode: commonValidation({
      required: true,
      digits: true,
    })
      .min(5, 'Must be 5 digits')
      .max(5, 'Must be 5 digits')
      .when('isOtherCountry', {
        is: false,
        otherwise: (d: any) =>
          commonValidation({
            required: true,
            digits: true,
          }),
      }),
  }),
  mailingAddress: Yup.object().shape({
    addressLine1: commonValidation({ noBlank: true }),
    addressLine2: commonValidation({ noBlank: true }),
    countryId: commonValidation({}),
    zipCode: commonValidation({
      required: true,
      digits: true,
    })
      .min(5, 'Must be 5 digits')
      .max(5, 'Must be 5 digits')
      .when('isOtherCountry', {
        is: false,
        otherwise: (d: any) => Yup.string().nullable(),
      }),
  }),
  previousHomeAddress: Yup.array()
    .of(
      Yup.object().shape({
        addressLine1: commonValidation({ required: true, noBlank: true }),
        addressLine2: commonValidation({
          required: false,
          alphanumeric: false, // alphanumeric: true, changed to false as per prod feedback for making free form
          noBlank: true,
        }),
        countryId: commonValidation({ required: true }),
        city: commonValidation({ required: true }),
        stateId: commonValidation({ required: true }).when('isOtherCountry', {
          is: false,
          otherwise: (d: any) => Yup.string().nullable(),
        }),
        state: commonValidation({ required: true }).when('isOtherCountry', {
          is: true,
          otherwise: (d: any) => Yup.string().nullable(),
        }),
        startDate: commonValidation({ required: true }),
        endDate: commonValidation({ required: true }),
        zipCode: commonValidation({
          required: true,
          digits: true,
        })
          .min(5, 'Must be 5 digits')
          .max(5, 'Must be 5 digits')
          .when('isOtherCountry', {
            is: false,
            otherwise: (d: any) => Yup.string().nullable(),
          }),
      })
    )
    .nullable(),
};

export const PARTICIPANT_DETAILS_VALIDATION = Yup.object().shape({
  dateOfBirth: Yup.string().required('Required field').nullable(),
  genderId: Yup.string().required('Required field').nullable(),
  maritalStatusId: Yup.string().required('Required field').nullable(),
  currentLegalResidenceId: Yup.string()
    .max(100, 'Maximum characters exceeds')
    .required('Required field')
    .nullable(),
  residenceStatusId: Yup.string().max(100, 'Maximum characters exceeds').nullable(),
  phoneNumber: Yup.string()
    .max(100, 'Maximum characters exceeds')
    .required('Required field')
    .nullable(),
  homeNumber: Yup.string()
    .max(100, 'Maximum characters exceeds')
    .required('Required field')
    .nullable(),
});

export const PARTICIPANT_EMPLOYMENT_DETAILS_VALIDATION = Yup.object().shape({
  currentEmployment: Yup.object().shape({
    employeeId: Yup.string()
      .max(100, 'Maximum characters exceeds')
      .required('Required field')
      .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
      .nullable(),
    employerName: Yup.string()
      .max(100, 'Maximum characters exceeds')
      .required('Required field')
      .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
      .nullable(),
    employmentCountryId: Yup.string().nullable(),
    employmentStateId: Yup.string().nullable(),
    employmentCityId: Yup.string().nullable(),
    employmentState: Yup.string().nullable(),
    employmentCity: Yup.string().nullable(),
    jobTitle: Yup.string().nullable(),
    workEmail: Yup.string().email().nullable(),
    costCentre: Yup.string().nullable(),
    hireDate: Yup.string().required('Required field').nullable(),
    employmentAddressLine1: Yup.string().nullable(),
    employmentAddressLine2: Yup.string().nullable(),
  }),
  previousEmployments: Yup.array().of(
    Yup.object().shape({
      jobTitle: Yup.string().required('Required field').nullable(),
      hireDate: Yup.string().required('Required field').nullable(),
      endDate: Yup.string().required('Required field').nullable(),
    })
  ),
});

export const PARTICIPANT_TAX_DETAILS_VALIDATION = {
  fullLegalName: Yup.string()
    .max(100, 'Maximum characters exceeds')
    .required('Required field')
    .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
    .nullable(),
  ssn: Yup.string()
    .max(100, 'Maximum characters exceeds')
    .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces')
    .required('Required field')
    .nullable(),
  countryLegalResidencyId: Yup.string().required('Required field').nullable(),
  governmentDocumentTypeId: Yup.string().required('Required field').nullable(),
  governmentDocumentIssuedCountryId: Yup.string().required('Required field').nullable(),
  governmentDocumentIdIssuedCityId: Yup.string().required('Required field').nullable(),
  governmentDocumentIdIssuedStateId: Yup.string().required('Required field').nullable(),
  governmentDocumentIdNo: Yup.string()
    .max(100, 'Maximum characters exceeds')
    .required('Required field')
    .nullable(),
  residenceStatusId: Yup.string().max(100, 'Maximum characters exceeds').nullable(),
  governmentDocumentIdIssueDate: Yup.string()
    .max(100, 'Maximum characters exceeds')
    .required('Required field')
    .nullable(),
  governmentDocumentIdZipOrPostalCode: Yup.string()
    .max(100, 'Maximum characters exceeds')
    .required('Required field')
    .nullable(),
};

export const CHANGE_CONTACT_NUMBER_VALIDATION = Yup.object().shape({
  contactNumber: commonValidation({
    required: true,
    numericPhone: true,
    noBlank: true,
  })
    .min(12, 'Must be 10 digits')
    .when('callingCodeStatus', {
      is: false,
      otherwise: (d: any) =>
        commonValidation({
          required: true,
          numericPhone: true,
          noBlank: true,
        }),
    }),
  callingCodeId: commonValidation({ required: true }),
});

export const CHANGE_PASSWORD_VALIDATION = Yup.object().shape({
  currentPassword: Yup.string().required('Required field'),
  newPassword: Yup.string().required('Required field').matches(passwordRegExp, 'Invalid Password'),
  repeatPassword: Yup.string()
    .required('Required field')
    .test('match', 'Password do not match', function (repeatPassword) {
      return repeatPassword === this.parent.newPassword;
    }),
});

export const ELECT_FORM_VALIDATION = Yup.object().shape({
  signature: Yup.string().required('Required field'),
});

export const SECURITY_QUESTIONS_VALIDATION = Yup.object().shape({
  securityQuestion1: Yup.string().required('Required field').nullable(),
  securityQuestion2: Yup.string().required('Required field').nullable(),
  securityQuestion3: Yup.string().required('Required field').nullable(),
  securityAnswer1: Yup.string()
    .required('Required field')
    .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces'),
  securityAnswer2: Yup.string()
    .required('Required field')
    .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces'),
  securityAnswer3: Yup.string()
    .required('Required field')
    .matches(/^\s*\S[\s\S]*$/, 'Must not contain blank spaces'),
});

export const W9_FORM_VALIDATION = Yup.object().shape({
  name: commonValidation({ required: true, noBlank: true }),
  limitedLiabilityCompanyText: commonValidation({ required: true, noBlank: true }).when(
    'federalTax',
    {
      is: 'limitedLiabilityCompany',
      otherwise: (d: any) => Yup.string().nullable(),
    }
  ),
  federalTaxClassificationOtherText: commonValidation({ required: true, noBlank: true }).when(
    'federalTax',
    {
      is: 'federalTaxClassificationOther',
      otherwise: (d: any) => Yup.string().nullable(),
    }
  ),
  address: commonValidation({ required: true, noBlank: true }),
  cityStateZipCode: commonValidation({ required: true, noBlank: true }),
  certificationDate: commonValidation({ required: true, noBlank: true }),
  ssn: commonValidation({ required: true, digits: true })
    .min(9, 'Must be 9 digits')
    .max(9, 'Must be 9 digits'),
  accept: commonValidation({ required: true, isBoolean: true }),
});

export const W8_FORM_VALIDATION = {
  name: commonValidation({ required: true, noBlank: true }),
  citizenshipCountryId: commonValidation({ required: true }),
  permanentAddress: commonValidation({ required: true }),
  permanentCity: commonValidation({ required: true }),
  permanentCountryId: commonValidation({ required: true }),
  hasDifferentMailingAddress: commonValidation({ isBoolean: true }),
  beneficialArticle: commonValidation({ required: true, noBlank: true }),
  beneficialIncomeType: commonValidation({ required: true }),
  beneficialAdditionalCondition: commonValidation({ required: true }),
  printName: commonValidation({ required: true, noBlank: true }),
  dateOfBirth: commonValidation({ required: true }),
  ssnOrIdentificationNumber: commonValidation({ digits: true })
    .min(9, 'Must be 9 digits')
    .max(9, 'Must be 9 digits'),
  foreignTaxIdentifyingNumber: commonValidation({ required: true }).when('ftinLegallyRequired', {
    is: false,
    otherwise: (d: any) => Yup.string().nullable(),
  }),
  // ftinLegallyRequired: commonValidation({ isBoolean: true }),
  beneficialCountryId: commonValidation({ required: true }),
  beneficialPercentage: commonValidation({ required: true, digits: true }),
  capacitySignCertify: commonValidation({ required: true, isBoolean: true }),
  certificationDate: commonValidation({ required: true }),
  accept: commonValidation({ required: true, isBoolean: true }),
};
